import moment from 'moment';

const getHourQuarter = (): number => {
  const now = moment().minutes();
  if (now === 0) return 0;
  return Math.trunc(now / 15) + 1;
};

export const Hours = (
  hourInitial: string,
  hourFinish: string,
  isToday = false
): string[] => {
  let cont = moment(
    isToday
      ? `${moment().format('HH')}:${getHourQuarter() * 15}`
      : `${hourInitial}:00`,
    'HH:mm'
  );
  const finishMoment = moment(hourFinish, 'HH');
  let hours = [cont.format('HH:mm')];

  while (cont.isBefore(finishMoment)) {
    cont = moment(cont).add(15, 'minutes');
    hours.push(cont.format('HH:mm'));
  }
  return hours;
};
